export const catalog_matrix = [
  {form_key:'token_type_id', catalog_key:'tokens_types'},
  {form_key:'responsible_id', catalog_key:'none', propname:'users'},
]